module.exports = __webpack_public_path__ + "static/img/qrCode.8e15b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/qrCode.png
// module id = sbWu
// module chunks = 8